import styled from '@emotion/styled';
import { Css, ITheme, Responsive, RowRole, themed } from '@/ui';
import isPropValid from '@emotion/is-prop-valid';
import { IJobEntry } from '../../../../contentful/types/IJob';
import * as JobTitle from './columns/JobTitle';
import * as Posted from './columns/Posted';
import * as JobType from './columns/JobType';
import * as DetailsLink from './columns/DetailsLink';
import { Color } from '../../../../styles/Color';

interface IJobListRowProps {
	job: IJobEntry;
}

const StyledRow = styled(RowRole, {
	shouldForwardProp: (props) => isPropValid(props),
})<{ pinned?: boolean }, ITheme>`
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: ${Css.pxToRem(20)} ${Css.pxToRem(8)};
	border-bottom: ${themed(({ border }) => border.default)};
	${({ pinned }) => pinned && `background-color: ${Color.Tertiary97}`};

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		font-size: ${Css.pxToRem(16)};
		padding-top: ${Css.pxToRem(16)};
	}
`;

const CellGroup = styled.div`
	display: flex;
	align-items: flex-start;
	flex: 1;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		flex-direction: column;
		justify-content: space-between;
		flex: 0.2;

		&:last-of-type {
			align-items: flex-end;
		}
	}
`;

export function JobListRow({ job }: IJobListRowProps) {
	const { title, employerName, employerLogo, type, slug, pinned } = job.fields;

	return (
		<StyledRow pinned={pinned}>
			<JobTitle.Cell
				title={title}
				employerName={employerName}
				employerLogo={employerLogo}
			/>

			<CellGroup>
				<Posted.Cell time={job.createdAt} />
			</CellGroup>
			<CellGroup>
				<JobType.Cell type={type} />
				<DetailsLink.Cell slug={slug} jobTitle={title} />
			</CellGroup>
		</StyledRow>
	);
}
